"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'BE-THESAURUS': ['fr', 'nl'],
    'CD-ATC': ['fr', 'nl'],
    'CD-DRUG-CNK': ['fr', 'nl'],
    'CD-INNCLUSTER': ['fr', 'nl'],
    ICPC: ['fr', 'nl'],
    ICD: ['fr', 'nl'],
};
//# sourceMappingURL=codelng.js.map